import classes from './ProductCard.module.scss';
import AddWishlist from '../../assets/icons/AddWishlist.svg';
import AddedWishlist from '../../assets/icons/AddedWishlist.svg';
import { ProductService } from '../../services/ProductService';
import { useLoader } from '../../customHooks/loader';
import { globalErrorHandler } from '../../utils/errorHandler';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export const ProductCard = ({ itemDetails, showWishlistButton, wishlist, wishlistOnClick }) => {

    const loader = useLoader();
    const navigate = useNavigate();

    const handleWishlistAddRemove = (e, id, operation, skuId) => {
        e.stopPropagation()
        if (id && operation) {
            ProductService.editWishlistProducts(
                { id, operation, skuId },
                handleWishlistOperationSuccess,
                globalErrorHandler,
                loader,
            )
        } else {
            toast.error("Please contact admin")
        }
    }

    const handleWishlistOperationSuccess = ({ data }) => {
        console.log(data.data);
        wishlistOnClick(data.data.id);
    }

    return (
        <div className={classes.singleProduct} onClick={() => navigate("/productDetails?skuId=" + itemDetails.skuId)}>
            {showWishlistButton && (wishlist ?
                <img src={AddedWishlist} alt="added to wishlist" className={classes.wishlist} onClick={(e) => handleWishlistAddRemove(e, itemDetails.id, "remove", itemDetails.skuId)} /> :
                <img src={AddWishlist} alt="not added to wishlist" className={classes.wishlist} onClick={(e) => handleWishlistAddRemove(e, itemDetails.id, "add", itemDetails.skuId)} />)}
            <img src={itemDetails.productImage} alt={itemDetails.productName} className={classes.singleProductImage} />
            <div className={classes.singleProductName}>{itemDetails.productName}</div>
            <div className={classes.singleProductDetails}>
                <div className={classes.singleProductPrice}>{parseInt(itemDetails.productPrice).toFixed(2)} د.إ</div>
                <div className={classes.singleProductCategory}>{itemDetails.productCategory}</div>

            </div>
        </div>
    )
}